<div
  class="sp-width__full sp-height__full sp-position__relative sp-overflow__hidden"
  [ngClass]="card_radius">
  <div
    class="sp-height__full sp-width__full sp-loading"
    [ngClass]="card_radius"></div>
</div>
